import { HTMLProps } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {
      padding: 'var(--bui-space-3) var(--bui-space-3)',
      paddingTop: 'var(--bui-space-2)',
    },
  });

export interface ActivityItemContentProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const ActivityItemContent = ({
  children,
  classes,
  className,
  ...rest
}: ActivityItemContentProps) => {
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
};

export default withStyles(styles)(ActivityItemContent);
